export default "__VITE_ASSET__r5ycY4i5__"